module.exports = __webpack_public_path__ + "static/img/home_fn_content_02.cfe3fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_fn_content_02.png
// module id = Rge7
// module chunks = 34